import React from 'react';
import { Card, Box, Group } from '@mantine/core';
import { FEED_ACTION_BAR_SX, FEED_CARD_HOVER } from './feedCardTheme';

export interface ShootDiscoverCardProps {
  /** Video/image + canvas overlay; host owns media element. */
  media: React.ReactNode;
  /** Gradient footer (author, expiry, linked caption). */
  overlayFooter?: React.ReactNode;
  /** Top-right toolbar (open, delete). */
  toolbar?: React.ReactNode;
  actionBar?: React.ReactNode;
}

/**
 * Presentational shoot card shell for the mixed discover feed.
 */
export function ShootDiscoverCard ({
  media,
  overlayFooter,
  toolbar,
  actionBar
}: ShootDiscoverCardProps) {
  return (
    <Card
      padding={0}
      radius="md"
      withBorder
      sx={{
        width: '100%',
        overflow: 'hidden',
        borderColor: 'var(--gs-border)',
        backgroundColor: 'var(--gs-bg-2)',
        ...FEED_CARD_HOVER,
        '@media (max-width: 575px)': {
          borderRadius: 0,
          borderLeft: 'none',
          borderRight: 'none'
        }
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          backgroundColor: '#000'
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            aspectRatio: '9 / 16',
            maxHeight: { base: 'min(85dvh, 720px)', sm: 'min(85vh, 720px)' },
            margin: '0 auto',
            backgroundColor: '#000',
            overflow: 'hidden'
          }}
        >
          {media}
          {toolbar}
          {overlayFooter}
        </Box>
      </Box>

      {actionBar && (
        <Group spacing="md" sx={FEED_ACTION_BAR_SX} align="center" wrap="nowrap">
          {actionBar}
        </Group>
      )}
    </Card>
  );
}
